import { del, get, post, put } from '../utils/networking';

export type HrSafetyReps = {
  teams: Array<{ id: number; name: string }>;
  representatives: Array<{
    userId: number;
    email: string;
    isMain: boolean;
    teamIds: number[];
  }>;
  users: Array<{ id: number; email: string }>;
};

export type SafetyRepRegistration = {
  userId?: number;
  email?: string;
  teamIds: number[];
};

const PATH = '/api/hr/safety-representatives';

export const getHrSafetyReps = () => get<HrSafetyReps>(PATH);

export const registerSafetyRep = (registration: SafetyRepRegistration) =>
  post<void>(PATH, registration);

export const updateSafetyRepTeams = (userId: number, teamIds: number[]) =>
  put<void>(`${PATH}/${userId}`, { teamIds });

export const removeSafetyRep = (userId: number) =>
  del<void>(`${PATH}/${userId}`);
